import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AngularFireAnalytics } from '@angular/fire/analytics';
import { IrisService } from '../app/iris/shared/iris.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  public title = 'pedia';
  public opened: boolean;
  public navmode: string = "over";
  public navItems: any[];

  constructor(
    private irisSrv: IrisService,
    private translate: TranslateService,
    private analytics: AngularFireAnalytics
  ) {
    console.log('app constructor');

    // IrisService初期化
    this.irisSrv.init()

    // init translate
    this.translate.setDefaultLang('ja');
    this.translate.use('ja');

    // google analytics enable/disable
    this.analytics.setAnalyticsCollectionEnabled(true);
  
    this.navItems = [
      { name: 'navigation.home', path: 'dashboard' },
      { name: "navigation.aboutus", path: 'aboutus' },
      { name: 'navigation.info', path: 'infoboard' },
      { name: 'navigation.voice', path: 'voiceboard' },
      { name: 'navigation.knowledge', path: 'knowledgeboard' },
      { name: 'navigation.systeminfo', path: 'systeminfo' },
      { name: 'navigation.scholarship', path: 'scholarship' },
    ];

  }

  ngOnInit() {
    console.log('app init');
  }

  ngOnDestroy() {
    console.log('app destroy');
    this.irisSrv.finalize();
  }
}
